
import React, { useEffect, useState } from 'react'
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import * as Yup from "yup";
import Sweetalert from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import ExamCenters from './ExamCenters';
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { useNavigate } from 'react-router-dom';
import { FaHandPointRight, FaPrint, FaWindowClose } from "react-icons/fa";
import Swal from 'sweetalert2';
import { IoMdCheckboxOutline } from 'react-icons/io';
import { CONTEXT_NAME, ERROR_MSG } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import { FaCircleChevronRight } from 'react-icons/fa6';
import Weboptions from '../WebOptions/Weboptions';
import { examCenterValidations } from '../../../CommonUtilities/Validations/Validations';
import TetPreview from '../Papers/TetPreview';
import { useSelector } from 'react-redux';

export const mappings = {
    loc_1: "GOVERNMENT/LOCAL BODIES",
    open_1: "GOVERNMENT/LOCAL BODIES",
    loc_8: "TRIBAL WELFARE (ASHRAM)",
    open_8: "TRIBAL WELFARE (ASHRAM)",
    loc_4: 'AP SOCIAL WELFARE RESIDENTIAL SOCIETY (APSWRS)',
    open_4: 'AP SOCIAL WELFARE RESIDENTIAL SOCIETY (APSWRS)',
    loc_2: 'MUNICIPAL',
    open_2: 'MUNICIPAL',
    loc_11: "MUNICIPAL CORPORATION",
    open_11: "MUNICIPAL CORPORATION",
    loc_10: "JUVENILE WELFARE",
    open_10: "JUVENILE WELFARE",
    loc_5: 'AP MODEL SCHOOLS (APMS)',
    open_5: 'AP MODEL SCHOOLS (APMS)',
    open_9: 'MJP BC WELFARE RESIDENTIAL SCHOOLS (MJPBCWRS))',
    loc_9: 'MJP BC WELFARE RESIDENTIAL SCHOOLS (MJPBCWRS)',
    loc_3: 'APTWRS (GURUKULAS)',
    open_3: 'APTWRS (GURUKULAS)',
    open_6: "AP RESIDENTIAL EDUCATIONAL INSTITUTIONS (APREIS)",
    loc_6: 'AP RESIDENTIAL EDUCATIONAL INSTITUTIONS (APREIS)',
    open_7: "DIFFERENTLY ABLED WELFARE",
    loc_7: 'DIFFERENTLY ABLED WELFARE',
    // Add additional mappings as needed
};

export default function PostApplication() {
     const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
        const tabdetails = useSelector((state) => state.reducers.loginreducer.tabdetails);
    let navigate = useNavigate()
    const [selectedPostCount, setSelectedPostCount] = useState(0);
    // balnced posts -------------------->
    const [previousPostCount, setPreviousPostCount] = useState(0)
    const [AlPaidPostCount, setAlPaidPost] = useState(0)
    function PreviousCountFunction() {
        let linkurl = config.url.CONTEXT_READ_URL + 'candidate-balance-posts'
        CommonAxiosGet(linkurl).then((response) => {
            if (response?.data.status === true) {
                setPreviousPostCount(response?.data?.data[0]?.balance_pay)
                setAlPaidPost(response?.data?.data[0]?.alr_paid_posts)
            }
            else {
                setAlPaidPost(0);
                setPreviousPostCount(0);
            }
        })
    }
    function SelectedOptionsFunction(set) {
        let linkurl = config.url.CONTEXT_READ_URL + 'candidate-post-preferences'
        CommonAxiosGet(linkurl).then((response) => {
            if (response?.data?.status === true) {
                let data_s = response?.data?.data;
                data_s?.forEach((data) => {
                    data.id = `${data?.management_id}999${data?.post_id}`;
                });
                set(data_s)
            }
        });
    }
    // et posts data -------------------->
    const [jsonData, setJsonData] = useState([]);
    const [postData, setPostData] = useState([]);
    const [OptionList, SetOptionList] = useState([])
    const [SelectedOption, SetSelectedOption] = useState([]);

   
    const [hideSubmit, setHideSubmit] = useState(false) // if it is true only submit btn appears .
    const [showOtp, setShowOtp] = useState(false)
    const getpostDataFunction = () => {
        let villUrl = config.url.CONTEXT_READ_URL + "candidate-posts";
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data.status === true) {
                let data = response?.data?.candidateposts?.map((item, index) => ({
                    ...item,
                    id: index + 1
                })) || [];
                let filterdata_len = data?.filter((val) => val.paid_dist_code !== null)?.length
                if (filterdata_len === data?.length) {
                    setHideSubmit(true)
                }
                setPostData(data)
                SelectedOptionsFunction(SetSelectedOption)
                let length = data?.length
                let newData = [];
                for (let i = 0; i < length; i++) {
                    newData.push(
                        {
                            postCheck: false,
                            postId: "",
                            // pstType: "",
                            // distCode: ""
                        });

                    setJsonData(newData);
                }
            }
            else {
                setJsonData([])
                setPostData([])
            }
        });
    };
    const ValidationSchema1 = Yup.object().shape({
        ...examCenterValidations.fields,
        postDetails: Yup.array().of(Yup.object().shape({
            postCheck: Yup.boolean(),
            distCode: Yup.string().when("postCheck", {
                is: (postCheck) => (postCheck === true),
                then: Yup.string().required(ERROR_MSG).nullable(),
                oterwise: Yup.string().nullable(),
            }),
        })),
    })
    
    const [examCenterData, setExamCenterData] = useState([])
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            payment: 0,
            postDetails: jsonData,
            otp: ''
        },
        // validationSchema: examCenterData?.length > 0 ? ValidationSchema2 : ValidationSchema1,
        onSubmit: (values) => {
            // console.log("values",values)

            let totalvaluesCount = OptionList?.length;
            let check_length = values?.postDetails?.filter(val => val?.postCheck === true)?.length

            if (check_length === 0) {
                return Sweetalert('Please Check Atleast One Post', 'warning')
            }
            if (totalvaluesCount !== 0) {
                return Sweetalert('Please Select Post-Managements', 'warning')
            }
            sendOtp()
        },
    })
    function SubmitPostValues() {
        let values = Formik?.values;
        const updatedPostDetails = values?.postDetails
            ?.filter(val => val?.postCheck === true)
            ?.map(val => ({
                ...val,
                distCode: typeof val?.distCode === 'string' && val?.distCode?.startsWith('Z')
                    ? val.distCode.slice(1) // remove leading 'Z'
                    : val.distCode
            }));

        let filtereddetails = {
            payment: values?.payment,
            postDetails: updatedPostDetails,
            otp: values?.otp
        }
        SelectedOption?.forEach((val, i) => {
            filtereddetails.postPref[i] = {
                postId: val.post_id,    // Correct assignment for cat
                preference: i + 1,         // Correct assignment for pref (starting at 1)
                managementId: val.management_id    // Assuming orgId comes from val
            };
        });
        let totalvaluesCount = OptionList?.length
        if (totalvaluesCount !== 0) {
            return Sweetalert('Please Select Post-Managements', 'warning')
        }
        if (showOtp === true && values?.otp !== "") {
            let url = config.url.CONTEXT_URL + "candidate-post-details"
            Swal.fire({
                title: 'Are you Sure?',
                html: `You have selected for <b style="color: blue;">${filtereddetails?.postDetails?.length}</b> posts 
                ${filtereddetails?.payment > 0 ? `,<br/>You have already paid for<b style="color: blue;"> ${previousPostCount} </b>posts<br/>
                Now you need to pay <b style="color: green;">${filtereddetails?.payment} Rs. </b>for <b style="color: blue;">
                ${filtereddetails?.postDetails?.length - previousPostCount} post</b> ` : ``}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: filtereddetails?.payment > 0 ? 'Proceed to Pay' : 'Submit',
            }).then((res) => {
                if (res.isConfirmed) {
                    CommonAxiosPost(url, filtereddetails).then((res) => {
                        if (res?.data?.status === true) {
                            if (filtereddetails?.payment > 0) {
                                let link = res?.data?.paymentUrl
                                window.open(link, '_self');
                            }
                            else {
                                Swal.fire({
                                    title: 'Successfully Submitted',
                                    text: 'Please click the below "click here" button to upload the documents.',
                                    icon: "info",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: 'Click Here',
                                    cancelButtonText: 'Cancel',
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        navigate('/FileUploads');
                                        window.location.reload();
                                    } else if (res.dismiss === Swal.DismissReason.cancel) {
                                        window.location.reload();
                                    }
                                });
                                Swal.fire({
                                    title: 'Successfully Submitted',
                                    text: 'Please click the below "click here" button to upload the documents.',
                                    icon: "info",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: 'Click Here',
                                    cancelButtonText: 'Cancel',
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        navigate('/FileUploads');
                                        window.location.reload();
                                    } else if (res.dismiss === Swal.DismissReason.cancel) {
                                        window.location.reload();
                                    }
                                });

                            }
                        }
                        else {
                            Sweetalert(res?.data?.sdesc, "error")
                        }
                    })
                }
            })
        }
        else {
            Sweetalert('Please Enter Otp to continue', 'warning')
        }
    }

    useEffect(() => {
        const count = Formik?.values?.postDetails?.filter((val) =>
            val?.postId !== "" && val?.postCheck === true).length || 0;
        if (count > 0) {
            setSelectedPostCount(count);
            let amount = (count - parseInt(previousPostCount)) * 300
            Formik.setFieldValue('payment', amount > 0 ? amount : 0)
        }
        else {
            setSelectedPostCount(0)
        }

    }, [Formik?.values])
    const [showOtpBtn, setOtpBtn] = useState(true);
    const [resendOtp, setResendOtp] = useState(false);
    function sendOtp() {
        Swal.fire({
            title: 'Are you Sure Want to Submit?',
            html: `Make Sure , OTP will be Send to your Mobile No.`, icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Send OTP",
        }).then((res) => {
            if (res.isConfirmed) {
                let otpUrl = config.url.CONTEXT_URL + "generate-post-pref-otp"
                CommonAxiosPost(otpUrl).then((rres) => {
                    if (rres?.data?.status === true) {
                        setShowOtp(true)
                        setOtpBtn(false)
                        setTimer(180);
                    }
                    else if (rres?.data?.scode === '03') {
                        Sweetalert(rres?.data?.sdesc, "warning")

                    } else {
                        Sweetalert('Internal Server Issue', "warning")
                    }

                })
            }
        })}

    useEffect(() => { getpostDataFunction(); PreviousCountFunction(); SelectedOptionsFunction(SetSelectedOption) }, [])
        const handleClose = () => setShow(false);
        const [show, setShow] = useState(() => {
            if (tabdetails?.latestTab === 3) {
                return tabdetails?.confirm === false;
            }
            return '';
        });
    const [showMoreDist, setMoreDist] = useState([])
    const [postName, setPostName] = useState('')
    const excludedKeys = ["open_no_of_posts", "local_no_of_posts", "dist_code"];


    const [timer, setTimer] = useState(180); // Timer in seconds
    useEffect(() => {
        let interval = null;
        if (!showOtpBtn) {
            interval = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer > 0) {
                        if (prevTimer < 122) {
                            setResendOtp(true);
                            return prevTimer - 1;
                        } else if (prevTimer > 1) {
                            return prevTimer - 1;
                        }
                        else {
                            clearInterval(interval);
                            setResendOtp(true); // Enable resend button when timer reaches 0
                            return 0;
                        }
                    }
                });
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [showOtpBtn]);

    const formatTime = (timeInSeconds) => {
        if (isNaN(timeInSeconds) || timeInSeconds < 0) {
            return "0:00";
        }
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = timeInSeconds % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };
    const resendOTP = () => {
        Formik.setFieldValue("otp", "")
        sendOtp()

    };
    return (
        <React.Fragment>
            <FormikProvider value={Formik}>
                <Form className="form-section" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange} >
                 <div className='pop pop-fix'>
                                <Modal size="xl" className='pop pop-fix' show={show} onHide={() => { handleClose(); navigate(-1) }} backdrop="static"
                                    style={{ maxWidth: '100%', width: '100%' }}
                                >
                                    <Modal.Header closeButton style={{}} >
                                        <Modal.Title>  {CONTEXT_NAME}</Modal.Title>
                                        {/* <button type="button" className='btn btn-end'
                                            onClick={() => {
                                                setShow(false);
                                                navigate(-1)
                                            }} style={{ fadeType: "out" }}
                                            variant="danger"
                                            aria-label="Close"><h4>
                                                <FaWindowClose className="text-danger" size={32} />
                                            </h4></button> */}
                                    </Modal.Header>
                                    <Modal.Body>
                                    {/* Test Modal */}
                                        <TetPreview handleClose={handleClose} />
                                    </Modal.Body>
                                </Modal></div>

                    <div className='px-4 mt-4'>
                        <Row className='px-3'>
                            <Col xxl={9} xl={9} lg={9} md={9} sm={12} xs={12} className='mt-2'>
                                {previousPostCount > 0 ?
                                    <h5><span style={{ fontFamily: 'bold' }} className='text-danger'>NOTE : </span> You have made payment for&nbsp;
                                        <span style={{ color: 'red', fontFamily: 'bold' }}>{AlPaidPostCount}</span> no. of posts earlier,please select below
                                        eligible posts. </h5>
                                    : ''}
                            </Col>
                            <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className='text-end' >
                                <div className='mb-2 mt-4'><FaHandPointRight size={30} />&emsp;
                                    <i style={{ background: "#2a9d8f" }} className="badge badge-success forgot fw-bold" onClick={() => navigate('/PrintApplication', { state: { status: 'preview' } })} onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            navigate('/PrintApplication', { state: { status: 'preview' } })
                                        }
                                    }}
                                        data-toggle="tooltip" animation="true"
                                    > Preview / Print <FaPrint title="Print" style={{ fontSize: '22px' }} /></i>
                                </div>
                            </Col>
                        </Row></div>


                     <div className='personal-block'>
    
                    <div className="personal-head ">
                        <span>Post Details</span>
                    </div>
                    <div className="personal-row pb-3">

                        <Row className='px-3'>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="mt-4 mt-xl-0">
                                <table className="table table-bordered table-responsive mb-0 mt-2"
                                    style={{ borderCollapse: 'collapse', border: '1px solid skyblue' }}>
                                    <thead style={{
                                        backgroundColor: '#dbe9f4'
                                    }}>
                                        <tr>
                                            <th>Check</th>
                                            <th>Post</th>
                                           
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {postData?.map((data, index) => {
                                            return (
                                                <tr key={index} id={index} style={{ background: data?.paid_dist_code !== null ? `#a5820726` : '' }}>
                                                    <td className='text-center'>
                                                    {
                                                        data?.is_applied === true ?
                                                            <IoMdCheckboxOutline color='green' size={20} /> :
                                                            <Field
                                                                name={`postDetails[${index}].postCheck`}
                                                                type="checkbox"
                                                                className="form-sub"
                                                                onClick={(e) => {


                                                                    if (e.target.checked) {
                                                                        Formik.setFieldValue(`postDetails[${index}].postId`, data?.post_id);

                                                                    }
                                                                    else {
                                                                        Formik.setFieldValue(`postDetails[${index}].postId`, '')
                                                                        Formik.setFieldValue(`postDetails[${index}].pstType`, '')
                                                                        SetOptionList(prev => prev.filter(option => option.post_id !== data?.post_id));
                                                                        SetSelectedOption(prev => prev.filter(option => option.post_id !== data?.post_id))
                                                                    }
                                                                    Formik.setFieldValue(`postDetails[${index}].distCode`, '')
                                                                }}
                                                            />
                                                    }
                                                    </td>
                                                    <td style={{ color: 'brown', fontFamily: 'Bold italic' }}><b>{data?.post_name}</b> </td>
                                                    
                                                </tr>
                                            )
                                        })}

                                    </tbody>
                                    <tfoot>
                                        <tr className='text-center'>
                                            <th colSpan={6}>
                                                {(previousPostCount > 0 && (parseInt(AlPaidPostCount) - parseInt(previousPostCount) > 0)) ?
                                                    <> You have already applied for {AlPaidPostCount - previousPostCount} posts.&nbsp;</>
                                                    : ''}
                                                {selectedPostCount > 0 && (<> you are now applying for {selectedPostCount}&nbsp;posts<span style={{ color: "green" }}>
                                                    &nbsp; ({parseInt(selectedPostCount) * 300} Rs.) </span>
                                                </>)}
                                                <pre />
                                                {(parseInt(selectedPostCount) - parseInt(previousPostCount)) > 0 ? (<>
                                                    You have to Pay an amount of  <span style={{ color: "green" }}>&nbsp;
                                                        {(parseInt(selectedPostCount) - parseInt(previousPostCount)) * 300} Rs. </span> &nbsp;
                                                    <span className='blink-color'
                                                    > PAYMENT</span>

                                                </>) :
                                                    (<>
                                                        {(parseInt(previousPostCount) - parseInt(selectedPostCount)) > 0 && (<>
                                                            Balance Amount   : <span style={{ color: "green" }}>&nbsp;
                                                                {(parseInt(previousPostCount) - parseInt(selectedPostCount)) * 300}  Rs.</span> &nbsp;
                                                        </>)}
                                                    </>)

                                                }

                                            </th>

                                        </tr>

                                    </tfoot>
                                </table>
                            </Col>
                        </Row>
                    </div></div>
                    {/* <div className="personal-head mt-3">
                        <span>Post & Management Preferences</span>
                    </div>
                    <div className="personal-row pb-3">
                        <Weboptions OptionList={OptionList} hideSubmit={hideSubmit} SetOptionList={SetOptionList} SetSelectedOption={SetSelectedOption} SelectedOption={SelectedOption} />
                    </div> */}

                    {/* <ExamCenters Formik={Formik} Data={examCenterData} /> */}

                    {/* {hideSubmit === false && */}
                        <Row className='pb-4'>
                            {showOtp === true &&
                                <React.Fragment>
                                    <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3}></Col>
                                    <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3} className='pt-2 mt-4'>
                                        {resendOtp === true ? <React.Fragment>
                                            <Form.Label className="input-lable mt-2">Didn't receive code? </Form.Label>&emsp;
                                            <Button variant="primary" type="button" className="" onClick={() => { resendOTP() }}>Resend OTP </Button>
                                        </React.Fragment>
                                            : ''}
                                    </Col>
                                    <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                        <React.Fragment>
                                            <p>
                                                Time Remaining:  {formatTime(timer)}
                                            </p>
                                        </React.Fragment>
                                    </Col>
                                    <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                        <Form.Group controlId="otp">
                                            <Field
                                                type="text"
                                                name="otp"
                                                className="input-field form-control"
                                                placeholder="Enter OTP"
                                                maxLength={6}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                        <div className='float-end'>
                                            <Button variant="success" type="button" className="submit-btn btn-success" onClick={() => { SubmitPostValues() }}>
                                                {Formik?.values?.payment > 0 ? 'Proceed to Pay & Submit' : 'Submit'}
                                            </Button>
                                        </div>
                                    </Col>
                                </React.Fragment>}
                            {showOtp === false && <React.Fragment>
                                <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}></Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-2'>
                                    <div className='float-end'><Button variant="primary" type="submit" className="submit-btn btn-primary"> Generate OTP </Button></div>
                                </Col>
                            </React.Fragment>}
                        </Row>
                        {/* } */}


                </Form>
            </FormikProvider>

        </React.Fragment>
    )
}
